<script setup>
import { computed } from "vue";
import { Github, Linkedin, Twitter } from "lucide-vue-next";

const props = defineProps({
  socials: { type: Object, default: () => ({}) },
});

// lucide-vue-next покрывает не все brand-иконки; для Dribbble и Figma
// рисуем inline SVG, чтобы не тащить дополнительную библиотеку.
const items = computed(() => {
  const s = props.socials || {};
  const list = [];
  if (s.dribbble) list.push({ key: "dribbble", href: s.dribbble });
  if (s.x || s.twitter) list.push({ key: "x", href: s.x || s.twitter });
  if (s.figma) list.push({ key: "figma", href: s.figma });
  if (s.github) list.push({ key: "github", href: s.github });
  if (s.linkedin) list.push({ key: "linkedin", href: s.linkedin });
  return list;
});
</script>

<template>
  <ul v-if="items.length" class="flex items-center gap-2" role="list">
    <li v-for="it in items" :key="it.key">
      <a
        :href="it.href"
        target="_blank"
        rel="noopener noreferrer"
        :aria-label="it.key"
        class="inline-flex h-8 w-8 items-center justify-center rounded-full bg-muted text-muted-foreground transition-colors hover:bg-foreground/10 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <svg
          v-if="it.key === 'dribbble'"
          viewBox="0 0 24 24"
          class="h-4 w-4"
          aria-hidden="true"
          fill="currentColor"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm6.605 4.61c1.18 1.43 1.9 3.24 1.93 5.21-.28-.06-3.06-.62-5.85-.26-.07-.16-.13-.32-.2-.49-.18-.41-.37-.82-.58-1.22 3.13-1.28 4.57-3.11 4.7-3.24zM12 3.86c2.16 0 4.15.77 5.69 2.05-.11.16-1.4 1.86-4.45 3-1.4-2.58-2.95-4.7-3.19-5.02.62-.02 1.27-.03 1.95-.03zm-3.86.45c.23.31 1.76 2.43 3.17 4.96-3.95 1.05-7.43 1.03-7.81 1.02C4.16 7.45 5.91 5.31 8.14 4.31zM3.93 12.01c0-.08 0-.16.01-.24.36.01 4.45.06 8.68-1.21.24.46.45.93.66 1.41-.11.03-.21.06-.32.09-4.37 1.41-6.69 5.26-6.88 5.58-1.34-1.49-2.15-3.47-2.15-5.63zM12 20.14c-1.96 0-3.76-.67-5.18-1.78.15-.31 1.85-3.58 6.61-5.24l.06-.02c1.18 3.06 1.66 5.62 1.79 6.36-.99.39-2.05.68-3.28.68zm5.07-1.62c-.09-.52-.55-3.01-1.65-6.04 2.62-.42 4.91.27 5.19.36-.36 2.31-1.7 4.31-3.54 5.68z"
          />
        </svg>
        <svg
          v-else-if="it.key === 'x'"
          viewBox="0 0 24 24"
          class="h-4 w-4"
          aria-hidden="true"
          fill="currentColor"
        >
          <path
            d="M18.244 2H21l-6.55 7.49L22 22h-6.84l-4.78-6.27L4.74 22H2l7.02-8.02L2 2h6.91l4.36 5.78L18.244 2zm-2.39 18h1.87L7.23 4H5.26l10.594 16z"
          />
        </svg>
        <svg
          v-else-if="it.key === 'figma'"
          viewBox="0 0 24 24"
          class="h-4 w-4"
          aria-hidden="true"
          fill="currentColor"
        >
          <path
            d="M9 22a3 3 0 0 0 3-3v-4H9a3 3 0 1 0 0 6zm-3-9a3 3 0 0 1 3-3h3v6H9a3 3 0 0 1-3-3zm0-6a3 3 0 0 1 3-3h3v6H9a3 3 0 0 1-3-3zm6 0a3 3 0 0 1 3-3h.01a3 3 0 0 1 0 6H15a3 3 0 0 1-3-3zm0 6a3 3 0 1 1 3.01-3A3 3 0 0 1 12 13z"
          />
        </svg>
        <Github
          v-else-if="it.key === 'github'"
          class="h-4 w-4"
          aria-hidden="true"
        />
        <Linkedin
          v-else-if="it.key === 'linkedin'"
          class="h-4 w-4"
          aria-hidden="true"
        />
        <Twitter v-else class="h-4 w-4" aria-hidden="true" />
      </a>
    </li>
  </ul>
</template>
